import {IEnvConfigType, IEnvName, IMatchEvents, LocaleType} from "../types/types";
import React, {useEffect, useRef} from "react";
import useLocalStore from "../store/useLocalStore";
import eventManager from "./eventManager";
import {getOverviewInfoApi, getTgAppLoginStatus} from "../api";
import env from "../config/env";
import matchlog from "../utils/matchlog";
import {useWalletModalStore} from "../store/useModalStore";
import useStore from "../store/useStore";
import {useQuery} from "@tanstack/react-query";
import {isSuccess} from "../api/request";
import {decodeBase64} from "../utils";

export default function useInit({
                                    theme,
                                    appid,
                                    events,
                                    endpoints,
                                    locale
                                }: {
    theme: "light" | "dark";
    appid: string;
    endpoints?: IEnvConfigType['endpoints']
    events?: IMatchEvents
    locale?: LocaleType
}) {

    const {
        setAppid,
        setEndpoints,
        setToken,
        setMid,
        token,
        setOverview,
        setTheme,
        setLocale,
        locale:realLocale
    } = useLocalStore();
    const walletModalStore = useWalletModalStore();
    const overviewLoadingRef = useRef(false);

    const searchParams = new URLSearchParams(window.location.search);
    const matchToken = searchParams.get('matchToken');
    const matchidt = searchParams.get('matchidt');

    const realEndpoints = endpoints || env.endpoints;

    useEffect(() => {
        setTheme(theme)
    }, [theme])

    useEffect(() => {
        setAppid(appid);
    }, [appid]);

    useEffect(() => {
        setEndpoints(realEndpoints);
    }, [realEndpoints]);

    useEffect(()=>{
        setLocale(locale||'en')
    },[locale])

    useEffect(() => {
        if (matchToken) {
            const tokenData = JSON.parse(atob(matchToken));
            if (tokenData && tokenData.mid && tokenData.token) {
                login({
                    // mid: tokenData.mid,
                    token: "Bearer " + tokenData.token,
                });
            }
        }
    }, [matchToken]);

    useEffect(() => {
        if (matchidt) {
            const tokenData = decodeURIComponent(matchidt);
            const data = JSON.parse(decodeBase64(tokenData))
            if(data){
                matchlog.log('matchidt',data)
                if(data.action=='login'){
                    const newtoken = data.token || `${data.token_type} ${data.access_token}`
                    login({
                        // mid: tokenData.mid,
                        token:newtoken
                    });
                }else if(data.action=='bind') {
                    eventManager.emit('onBind', {
                        type:data.type
                    })
                    if (events && events.onBind) {
                        events.onBind({
                            type:data.type
                        })
                    }
                }
                const url = window.location.href;
                const urlObj = new URL(url);
                urlObj.searchParams.delete('matchidt');
                window.history.replaceState({}, '', urlObj.toString());
                return;
            }
        }
    }, [matchidt]);

    useEffect(() => {
        const onLoginMessage = (event: MessageEvent) => {
            const res = event.data;
            if (res.event === 'login' && res.data && (res.data.token || (res.data.token_type && res.data.access_token))) {
                login({
                    // mid: res.data.mid,
                    token: res.data.token || `${res.data.token_type} ${res.data.access_token}`,
                });
            } else if (res.event == 'bind') {
                walletModalStore.close()
                eventManager.emit('onBind', res.data)
                if (events && events.onBind) {
                    events.onBind(res.data)
                }
            }
        }
        window.addEventListener('message', onLoginMessage);
        return () => {
            window.removeEventListener('message', onLoginMessage);
        };
    }, []);

    const loadOverview = async () => {
        matchlog.log('loadOverview')
        if (overviewLoadingRef.current) {
            return;
        }
        overviewLoadingRef.current = true;
        try {
            const res = await getOverviewInfoApi();

            setOverview(res.data)

            return res.data;
        } catch (err) {
            console.error('overview error', err);
        } finally {
            overviewLoadingRef.current = false;
        }
    };

    useEffect(() => {
        if (token) {
            loadOverview();
        }
    }, [token]);

    const login = async ({ token}: { token: string }) => {
        // setMid(mid);
        setToken(token);
        const overview = await loadOverview();

        eventManager.emit('onLogin', {
            // mid,
            token,
            did: overview?.did as string,
        });
        if (events && events?.onLogin) {
            events.onLogin({
                // mid,
                token,
                did: overview?.did as string,
            });
        }
    };



    return {
        loadOverview,
        login,
        endpoints:realEndpoints,
        locale:realLocale
    }

}